import { FeatureFlag, Site } from '@ps/web-core-enums';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import useFeature from '@swf/core/hooks/useFeature';
import useWizardJump from '@swf/core/hooks/useWizardJump';
import { select } from '@swf/core/store';

import createSingleton from '../../../../hooks/useSingleton';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';
import RMFTransitionScreen from '../RMFTransitionScreen/RMFTransitionScreen';

import {
  TXTCLI_Your_full_name,
  TXTWCL_OkX_N0X_WhatXs_your_nameX,
  TXTWCL_Please_provide_your_full_legal_ELL,
  TXTWCL_Please_use_your_legal_name_tha_ELL
} from './RMFLegalName.messages.json';
import Alias from './components/Alias/Alias';
import FamilyName from './components/FamilyName/FamilyName';
import GivenName from './components/GivenName/GivenName';
import MiddleName from './components/MiddleName/MiddleName';

const [getValue, setValue] = createSingleton(false);

const RMFLegalName: React.FunctionComponent = () => {
  const userId = useSelector(select.account.getUserId);
  const site = useSelector(select.cms.getSiteId);
  const isFirstScreen = useRmfFirstScreen();
  const hasBeenShown = getValue();
  const { jumpBack } = useWizardJump();
  const welcomeBonus = useFeature(FeatureFlag.SwcWelcomeBonusScreen);
  const showTransitionIfNotFirst = site === Site.IT && !welcomeBonus;
  const [shouldAutoFocus, setShouldAutoFocus] = useState<boolean>(
    !isFirstScreen || hasBeenShown || showTransitionIfNotFirst
  );

  useEffect(() => {
    setShouldAutoFocus(!isFirstScreen || hasBeenShown || showTransitionIfNotFirst);
  }, [isFirstScreen, hasBeenShown, showTransitionIfNotFirst]);

  return (
    <Container
      page={RMFLegalName}
      headerProps={{
        buttons: {
          back: !isFirstScreen,
          onBackClick: showTransitionIfNotFirst
            ? () => jumpBack('#rmf.rmf-it-bonus-offer')
            : undefined
        },
        title: <Translation {...TXTCLI_Your_full_name} />
      }}
      pageTopTitle={<Translation {...TXTWCL_OkX_N0X_WhatXs_your_nameX} values={{ 0: userId }} />}
      pageTopSubtitle={
        <Translation
          {...(site === Site.CAON
            ? TXTWCL_Please_provide_your_full_legal_ELL
            : TXTWCL_Please_use_your_legal_name_tha_ELL)}
        />
      }
    >
      {(isFirstScreen || showTransitionIfNotFirst) && (
        <RMFTransitionScreen getValue={getValue} setValue={setValue} />
      )}
      <fieldset>
        <GivenName autoFocus={shouldAutoFocus} />
        <MiddleName />
        <FamilyName />
        <Alias />
      </fieldset>
      <CTAButton />
    </Container>
  );
};

RMFLegalName.displayName = 'RMFLegalName';

export default RMFLegalName;
